module.exports = __webpack_public_path__ + "images/144_640.jpg";